var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 670,
    height: 670,
    viewBox: "0 0 670 670",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0719 264.556C68.0719 264.556 43.9519 367.629 111.14 457.436C178.327 547.242 295.443 582.149 389.592 612.876C483.74 643.602 571.912 608.119 604.983 529.005C638.055 449.891 571.255 407.279 556.515 303.885C541.775 200.491 553.541 170.796 484.825 92.165C416.11 13.5338 275.102 15.3562 179.761 96.185C84.4199 177.014 68.0719 264.556 68.0719 264.556Z",
    fill: "#7764F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.0719 264.556C68.0719 264.556 43.9519 367.629 111.14 457.436C178.327 547.242 295.443 582.149 389.592 612.876C483.74 643.602 571.912 608.119 604.983 529.005C638.055 449.891 571.255 407.279 556.515 303.885C541.775 200.491 553.541 170.796 484.825 92.165C416.11 13.5338 275.102 15.3562 179.761 96.185C84.4199 177.014 68.0719 264.556 68.0719 264.556Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.665 258.62C133.665 258.62 134.469 358.276 134.469 384.58C134.469 410.884 133.665 568.522 133.665 568.522",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.469 284.187L168.746 263.458L238.118 271.431L176.719 251.491L239.712 240.329H168.746L223.766 198.87L161.577 229.971L197.449 168.572L149.611 223.593L166.361 143.059L135.259 218.005L132.07 134.295L125.692 219.599L91.763 144.238L115.334 226.782L64.5878 171.413L108.955 239.539L46.136 194.716L104.962 251.491L38.364 215.11L99.3876 256.275L44.193 249.079L97.793 264.248L54.8728 271.417L99.3876 269.836L73.07 287.377L135.259 270.627L193.469 284.187Z",
    fill: "#7764F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.746 359.12C109.746 359.12 107.361 379.85 108.955 387.823C110.645 397.024 111.443 406.367 111.341 415.722C111.341 426.093 112.145 470.139 112.145 477.362C112.145 484.584 111.341 545.501 111.341 551.062V570.197",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.145 469.361C112.145 469.361 115.334 408.566 118.523 400.66C121.712 392.754 124.097 395.072 124.901 385.504C125.705 375.937 125.692 371.957 127.287 368.768C128.558 365.922 129.623 362.989 130.476 359.991L132.07 353.612",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.746 379.863L144.036 359.133L213.395 367.106L152.01 347.167L214.99 336.005H144.036L199.043 294.545L136.854 325.647L172.739 264.248L124.901 319.268L141.638 238.734L110.55 313.681L107.361 229.971L100.982 315.275L76.2593 237.944L90.6107 322.458L46.7659 259.464L84.2323 335.214L26.7195 297.627L80.2525 347.167L20.8905 322.873L74.6647 351.951L18.9475 347.14L73.0701 359.924L35.4563 368.5L74.6647 365.512L48.3605 383.052L110.55 366.302L168.746 379.863Z",
    fill: "#7764F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.048 504.765L138.556 489.261L190.454 495.224L144.519 480.31L191.647 471.962H138.556L179.721 440.941L133.196 464.203L160.036 418.268L124.245 459.433L136.774 399.186L113.498 455.252L111.113 392.62L106.342 456.444L87.8502 398.583L98.597 461.818L65.7804 414.69L93.8266 471.359L50.7858 443.245L90.8384 480.31L46.4308 462.126L86.6576 483.888L44.9702 480.296L85.465 489.851L57.325 496.269L86.6576 494.031L66.973 507.15L113.498 494.621L157.048 504.765Z",
    fill: "#7764F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9038 547.591L70.8456 576.039C69.5479 578.199 68.6987 580.599 68.3487 583.095C67.9988 585.59 68.1553 588.131 68.8088 590.565L76.3798 618.825C76.916 620.829 78.1012 622.598 79.7499 623.856C81.3986 625.115 83.4178 625.791 85.4918 625.78H163.212C165.283 625.784 167.297 625.103 168.941 623.843C170.584 622.582 171.764 620.813 172.297 618.812L179.881 590.551C180.537 588.118 180.696 585.578 180.348 583.083C180 580.587 179.153 578.187 177.858 576.026L160.8 547.591C160.227 546.639 159.417 545.851 158.45 545.304C157.483 544.757 156.39 544.469 155.279 544.469H93.438C92.3244 544.467 91.2293 544.753 90.2594 545.3C89.2895 545.848 88.478 546.637 87.9038 547.591Z",
    fill: "white",
    stroke: "#263238",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M535.008 74.584H374.972V301.66H535.008V74.584Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M528.911 83.2266H381.069V293.004H528.911V83.2266Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M381.284 276.174C398.57 252.121 425.008 238.654 452.585 229.006C476.196 220.765 492.865 209.482 504.979 186.836C522.573 153.953 513.528 110.845 504.979 83.3613",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M454.26 83.5488C465.61 99.0928 478.983 125.652 468.732 156.029C460.692 179.734 445.295 189.047 424.016 173.811C411.246 164.672 397.216 148.485 381.257 141.129",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M455.332 293.031C462.756 288.555 472.618 280.488 483.834 265.99C488.912 259.437 498.386 247.632 508.222 250.593C519.304 253.93 519.947 271.082 517.361 279.966C515.978 284.52 514.019 288.879 511.532 292.937",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M415.561 227.331C425.241 227.331 433.088 219.484 433.088 209.804C433.088 200.124 425.241 192.276 415.561 192.276C405.881 192.276 398.034 200.124 398.034 209.804C398.034 219.484 405.881 227.331 415.561 227.331Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M447.56 100.741C447.558 101.994 447.184 103.218 446.485 104.259C445.787 105.299 444.797 106.11 443.638 106.587C442.48 107.065 441.206 107.189 439.977 106.943C438.749 106.697 437.621 106.092 436.736 105.205C435.85 104.318 435.248 103.189 435.005 101.959C434.761 100.73 434.887 99.4566 435.368 98.2992C435.848 97.1419 436.66 96.1528 437.702 95.4569C438.744 94.761 439.969 94.3897 441.222 94.3896C442.055 94.3896 442.881 94.554 443.651 94.8734C444.42 95.1928 445.12 95.6608 445.709 96.2508C446.297 96.8408 446.764 97.5411 447.082 98.3116C447.399 99.0821 447.562 99.9078 447.56 100.741Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M511.625 230.345C515.629 230.345 518.875 227.1 518.875 223.096C518.875 219.092 515.629 215.847 511.625 215.847C507.622 215.847 504.376 219.092 504.376 223.096C504.376 227.1 507.622 230.345 511.625 230.345Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M557.641 114.102V347.717H573.118V114.102H557.641ZM565.386 124.929C565.103 124.962 564.816 124.934 564.544 124.848C564.272 124.762 564.021 124.619 563.808 124.429C563.595 124.24 563.424 124.007 563.308 123.747C563.191 123.486 563.13 123.204 563.13 122.919C563.13 122.633 563.191 122.351 563.308 122.091C563.424 121.831 563.595 121.598 563.808 121.408C564.021 121.218 564.272 121.076 564.544 120.99C564.816 120.904 565.103 120.876 565.386 120.909C565.879 120.966 566.334 121.202 566.665 121.573C566.995 121.943 567.177 122.422 567.177 122.919C567.177 123.415 566.995 123.894 566.665 124.265C566.334 124.635 565.879 124.872 565.386 124.929Z",
    fill: "#7764F5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M568.777 329.641H512.135C513.796 332.615 518.165 339.021 525.468 340.213C535.035 341.727 545.568 338.203 554.68 347.771H576.12C585.178 338.203 595.751 341.727 605.318 340.213C612.635 339.061 617.003 332.615 618.718 329.641H568.777Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M287.216 383.683H205.033V491.78H287.216V383.683Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M326.518 383.683H244.335V491.78H326.518V383.683Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M320.273 439.252H250.593V480.162H320.273V439.252Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M320.273 391.91H250.593V432.82H320.273V391.91Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M297.762 408.7H273.105V416.03H297.762V408.7Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M297.762 453.362H273.105V460.692H297.762V453.362Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M173.651 382.57H157.102C221.596 424.11 271.551 545.689 272.757 625.794H282.137C281.561 583.343 268.563 531.712 246.252 483.553C225.763 439.172 200.357 404.01 173.651 382.57Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M218.621 382.57C191.915 404.01 166.508 439.172 145.953 483.552C123.642 531.712 110.644 583.342 110.068 625.78H119.448C120.654 545.675 170.609 424.043 235.103 382.557L218.621 382.57Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M389.753 383.844H373.204C437.684 425.384 487.653 546.962 488.859 627.067H498.306C497.73 584.616 484.732 532.986 462.421 484.826C441.865 440.445 416.445 405.284 389.753 383.844Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M434.723 383.844C408.017 405.284 382.61 440.445 362.041 484.826C339.744 532.986 326.732 584.616 326.156 627.121H335.617C336.809 547.015 386.778 425.384 451.272 383.897L434.723 383.844Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M395.715 224.879L400.003 215.352H165.932L165.651 215.968L161.631 224.879L213.717 380.279H447.801L395.715 224.879Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M455.841 380.279H221.757L165.932 215.352H400.003L455.841 380.279Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M430.02 365.592H237.622L191.741 230.038H384.138L430.02 365.592Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M313.882 302.799H381.257L372.024 275.49H304.636L313.882 302.799Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M305.52 278.103H372.909L372.024 275.49H304.636L305.52 278.103Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M374.141 273.173H304.153L298.351 256.034H357.606L374.141 273.173Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M304.649 276.375H375.227L374.141 273.173H303.563L304.649 276.375Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M313.56 266.499H266.338L274.07 289.346H321.292L313.56 266.499Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M313.56 266.499H266.338L267.129 268.817H314.351L313.56 266.499Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M281.534 243.224L262.372 262.546H313.761L281.534 243.224Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M282.418 245.863L267.183 261.233H308.066L282.418 245.863Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M254.788 334.29H251.706L239.632 298.579H242.701L254.788 334.29Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M401.464 334.183H259.143L247.096 298.579H389.431L401.464 334.183Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M390.758 302.505H248.423L247.096 298.579H389.431L390.758 302.505Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M331.731 297.48H235.304L239.86 286.935H328.166L331.731 297.48Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M314.458 299.678H236.041L235.304 297.48H313.721L314.458 299.678Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M389.056 297.48H309.54L321.962 334.183H401.464L389.056 297.48Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M387.729 299.61H312.3L323.998 334.182H399.427L387.729 299.61Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M383.079 304.502H320.26L330.31 334.183H393.129L383.079 304.502Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M341.137 319.402H326.947L325.057 313.814H339.234L341.137 319.402Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M356.279 319.402H342.089L340.199 313.814H354.376L356.279 319.402Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M343.389 326.089H329.211L327.309 320.501H341.499L343.389 326.089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M358.531 326.089H344.354L342.451 320.501H356.641L358.531 326.089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M345.653 332.775H331.462L329.573 327.188H343.763L345.653 332.775Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M360.795 332.775H346.604L344.715 327.188H358.905L360.795 332.775Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M371.421 319.402H357.231L355.341 313.814H369.532L371.421 319.402Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M386.563 319.402H372.373L370.483 313.814H384.674L386.563 319.402Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M373.686 326.089H359.495L357.606 320.501H371.783L373.686 326.089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M388.828 326.089H374.637L372.748 320.501H386.925L388.828 326.089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M375.937 332.775H361.746L359.857 327.188H374.048L375.937 332.775Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M391.079 332.775H376.902L374.999 327.188H389.19L391.079 332.775Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M336.46 262.091L306.619 297.909H390.516L336.46 262.091Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M338.109 266.981L314.377 295.47H381.109L338.109 266.981Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M315.838 266.727H263.779L262.372 262.546H314.431L315.838 266.727Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M311.684 285.621H280.931L274.915 267.826H305.668L311.684 285.621Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M307.289 285.621H285.326L279.31 267.826H301.272L307.289 285.621Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M297.185 285.621H295.43L289.413 267.826H291.168L297.185 285.621Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M282.686 277.487L282.164 275.946H303.912L304.434 277.487H282.686Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M294.545 328.448H263.792L256.355 306.485H287.108L294.545 328.448Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M290.15 328.448H268.174L260.75 306.485H282.713L290.15 328.448Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M280.047 328.448H278.291L270.854 306.485H272.61L280.047 328.448Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M264.904 318.411L264.261 316.508H286.076L286.72 318.411H264.904Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M309.004 306.914H297.145L306.284 333.942H318.143L309.004 306.914Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M307.597 308.603H299.691L306.766 329.547H314.672L307.597 308.603Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M325.245 308.75L324.856 307.584H322.779L323.181 308.75H325.245Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M326.156 308.75H328.233L327.831 307.584H325.768L326.156 308.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M325.459 309.379H323.396L323.891 310.84H325.955L325.459 309.379Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M326.371 309.379L326.866 310.84H328.943L328.448 309.379H326.371Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M333.044 308.75L332.642 307.584H330.578L330.967 308.75H333.044Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M333.955 308.75H336.019L335.63 307.584H333.566L333.955 308.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M333.258 309.379H331.181L331.677 310.84H333.754L333.258 309.379Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M334.169 309.379L334.665 310.84H336.729L336.233 309.379H334.169Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M340.829 308.75L340.44 307.584H338.363L338.765 308.75H340.829Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M341.74 308.75H343.817L343.415 307.584H341.352L341.74 308.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M341.044 309.379H338.98L339.476 310.84H341.539L341.044 309.379Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M341.955 309.379L342.45 310.84H344.527L344.032 309.379H341.955Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M348.628 308.75L348.226 307.584H346.162L346.551 308.75H348.628Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M349.539 308.75H351.603L351.214 307.584H349.15L349.539 308.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M348.842 309.379H346.765L347.261 310.84H349.338L348.842 309.379Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M349.753 309.379L350.249 310.84H352.313L351.817 309.379H349.753Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M356.413 308.75L356.025 307.584H353.948L354.35 308.75H356.413Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M357.325 308.75H359.402L359 307.584H356.936L357.325 308.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M356.628 309.379H354.564L355.06 310.84H357.123L356.628 309.379Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M357.539 309.379L358.034 310.84H360.111L359.616 309.379H357.539Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M364.212 308.75L363.81 307.584H361.747L362.135 308.75H364.212Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M365.123 308.75H367.187L366.798 307.584H364.735L365.123 308.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M364.426 309.379H362.363L362.845 310.84H364.922L364.426 309.379Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M365.338 309.379L365.834 310.84H367.897L367.415 309.379H365.338Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M371.997 308.75L371.609 307.584H369.532L369.934 308.75H371.997Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M372.909 308.75H374.986L374.597 307.584H372.52L372.909 308.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M372.212 309.379H370.148L370.644 310.84H372.708L372.212 309.379Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M373.136 309.379L373.619 310.84H375.696L375.2 309.379H373.136Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M379.796 308.75L379.394 307.584H377.331L377.719 308.75H379.796Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M380.707 308.75H382.771L382.382 307.584H380.319L380.707 308.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M380.01 309.379H377.947L378.429 310.84H380.506L380.01 309.379Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M380.922 309.379L381.418 310.84H383.481L382.985 309.379H380.922Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M256.61 263.351H219.881",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M214.306 248.985L227.867 290.485",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M363.556 255.364H383.522",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M377.934 249.776L401.879 316.026",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M263.725 249.253H221.515L219.237 241.428H261.434L263.725 249.253Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M228.135 242.031L230.226 248.986",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M229.529 245.85H262.211",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M202.139 285.701L233.334 377.88H323.57L202.139 285.701ZM227.371 319.456L287.296 364.935H242.755L227.371 319.456Z",
    fill: "#7764F5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M430.676 376.768H133.236V386.831H430.676V376.768Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M463.104 376.768H224.825V386.831H463.104V376.768Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M213.971 209.496C213.157 209.492 212.372 209.193 211.763 208.653C211.154 208.112 210.762 207.369 210.662 206.561L196.672 95.5557C196.562 94.6672 196.809 93.7714 197.359 93.0652C197.91 92.3591 198.718 91.9005 199.607 91.7903C200.495 91.6801 201.391 91.9274 202.097 92.4778C202.803 93.0281 203.262 93.8364 203.372 94.7249L217.362 205.717C217.471 206.598 217.227 207.487 216.682 208.188C216.136 208.889 215.335 209.345 214.454 209.456C214.295 209.486 214.133 209.499 213.971 209.496Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M200.866 101.519C200.333 101.563 199.804 101.394 199.396 101.048C198.987 100.703 198.733 100.209 198.689 99.6762C198.644 99.1431 198.813 98.6142 199.159 98.2058C199.504 97.7974 199.998 97.5431 200.531 97.4987L287.055 82.6783C287.588 82.5876 288.135 82.7125 288.576 83.0254C289.017 83.3382 289.316 83.8135 289.407 84.3466C289.497 84.8796 289.372 85.4269 289.06 85.8679C288.747 86.3089 288.271 86.6076 287.738 86.6983L201.215 101.492C201.1 101.514 200.983 101.523 200.866 101.519Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M202.622 112.011C202.358 112.034 202.092 112.004 201.839 111.925C201.587 111.845 201.352 111.716 201.149 111.545C200.947 111.375 200.779 111.166 200.657 110.931C200.535 110.696 200.46 110.439 200.437 110.175C200.415 109.911 200.444 109.645 200.524 109.393C200.604 109.14 200.733 108.906 200.903 108.703C201.073 108.5 201.282 108.333 201.517 108.211C201.752 108.088 202.009 108.014 202.273 107.991L288.81 93.1303C289.074 93.0863 289.344 93.0947 289.605 93.1551C289.866 93.2154 290.112 93.3266 290.33 93.4821C290.548 93.6376 290.733 93.8345 290.874 94.0616C291.016 94.2886 291.111 94.5413 291.155 94.8053C291.199 95.0692 291.191 95.3393 291.131 95.6C291.07 95.8607 290.959 96.1069 290.804 96.3247C290.648 96.5424 290.451 96.7274 290.224 96.8691C289.997 97.0107 289.744 97.1063 289.48 97.1503L202.957 111.984L202.622 112.011Z",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M288.274 82.0352L276.911 100.38L297.011 102.135L298.753 97.7668L288.274 82.0352Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M297.011 102.805L276.911 101.049C276.797 101.039 276.688 101 276.594 100.935C276.5 100.871 276.424 100.784 276.373 100.682C276.322 100.58 276.298 100.466 276.303 100.353C276.308 100.239 276.342 100.128 276.402 100.031L287.698 81.7398C287.758 81.6455 287.842 81.5678 287.94 81.514C288.038 81.4601 288.149 81.4318 288.261 81.4316C288.371 81.4347 288.479 81.4629 288.576 81.514C288.674 81.5651 288.758 81.6377 288.823 81.7264L299.316 97.458C299.365 97.5533 299.391 97.659 299.391 97.7662C299.391 97.8735 299.365 97.9792 299.316 98.0744L297.56 102.443C297.51 102.547 297.432 102.636 297.335 102.699C297.239 102.763 297.127 102.799 297.011 102.805ZM278.05 99.8164L296.569 101.424L298.002 97.8198L288.287 83.2406L278.05 99.8164Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M335.63 130.114L324.106 104.761C324.106 101.787 317.848 99.4014 310.116 99.4014C302.384 99.4014 296.14 101.84 296.14 104.761L284.603 130.114C283.652 131.032 283.087 132.278 283.021 133.598C283.021 139.347 295.162 144.023 310.116 144.023C325.071 144.023 337.211 139.347 337.211 133.598C337.146 132.278 336.581 131.032 335.63 130.114Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M310.116 144.721C294.546 144.721 282.352 139.843 282.352 133.625C282.415 132.158 283.033 130.769 284.08 129.739L295.51 104.601C295.698 101.224 301.929 98.7051 310.157 98.7051C318.384 98.7051 324.629 101.224 324.816 104.601L336.233 129.739C337.265 130.765 337.868 132.145 337.921 133.599C337.881 139.816 325.687 144.721 310.116 144.721ZM310.116 100.072C302.277 100.072 296.81 102.551 296.81 104.789C296.808 104.882 296.785 104.974 296.743 105.057L285.219 130.423C285.192 130.489 285.151 130.548 285.099 130.597C284.288 131.403 283.81 132.484 283.759 133.625C283.759 138.905 295.819 143.381 310.183 143.381C324.548 143.381 336.608 138.905 336.608 133.625C336.545 132.473 336.041 131.389 335.201 130.597C335.158 130.544 335.122 130.485 335.094 130.423L323.557 105.057C323.536 104.968 323.536 104.877 323.557 104.789C323.436 102.524 317.969 100.045 310.116 100.045V100.072Z",
    fill: "#263238"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M298.753 80.2803L296.14 104.762H324.106L321.48 80.2803H298.753Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M324.106 105.431H296.14C296.044 105.432 295.949 105.412 295.861 105.373C295.773 105.333 295.695 105.276 295.631 105.203C295.57 105.132 295.524 105.049 295.496 104.959C295.468 104.869 295.46 104.774 295.47 104.681L298.15 80.2124C298.167 80.0488 298.243 79.897 298.364 79.7858C298.485 79.6746 298.642 79.6118 298.807 79.6094H321.587C321.753 79.6115 321.912 79.6738 322.035 79.7848C322.159 79.8957 322.237 80.0477 322.257 80.2124L324.937 104.681C324.945 104.775 324.934 104.87 324.904 104.96C324.874 105.05 324.826 105.133 324.763 105.203C324.686 105.3 324.584 105.373 324.468 105.414C324.351 105.454 324.226 105.46 324.106 105.431ZM296.877 104.091H323.356L320.877 80.9494H299.356L296.877 104.091Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M321.48 80.2795C321.48 82.6915 316.401 84.6479 310.117 84.6479C303.832 84.6479 298.82 82.6915 298.82 80.2795C298.82 77.8675 303.912 75.9111 310.184 75.9111C316.455 75.9111 321.48 77.8675 321.48 80.2795Z",
    fill: "#636363"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M310.116 85.318C304.287 85.318 298.056 83.5626 298.056 80.2796C298.056 76.9966 304.26 75.2412 310.116 75.2412C315.972 75.2412 322.176 77.01 322.176 80.2796C322.176 83.5492 315.959 85.318 310.116 85.318ZM310.116 76.5812C303.818 76.5812 299.396 78.5376 299.396 80.2796C299.396 82.0216 303.791 83.978 310.116 83.978C316.441 83.978 320.836 82.035 320.836 80.2796C320.836 78.5242 316.414 76.5812 310.116 76.5812Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M217.884 195.131L207.245 214.172L212.712 218.085C214.258 219.184 216.108 219.774 218.005 219.773C219.369 219.772 220.715 219.464 221.944 218.872C223.174 218.281 224.254 217.421 225.107 216.356L226.849 214.172L221.248 196.243L217.884 195.131Z",
    fill: "#263238"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M218.005 220.444C215.967 220.446 213.979 219.809 212.323 218.621L206.856 214.722C206.721 214.627 206.626 214.485 206.589 214.325C206.552 214.164 206.575 213.995 206.655 213.851L217.308 194.796C217.382 194.659 217.502 194.553 217.647 194.497C217.791 194.441 217.952 194.437 218.099 194.488L221.462 195.613C221.562 195.647 221.652 195.703 221.726 195.778C221.801 195.852 221.857 195.943 221.891 196.042L227.492 213.971C227.526 214.076 227.533 214.187 227.512 214.295C227.491 214.403 227.442 214.504 227.371 214.588L225.629 216.785C224.714 217.928 223.554 218.85 222.234 219.484C220.914 220.117 219.469 220.445 218.005 220.444ZM208.129 213.971L213.114 217.536C214.866 218.789 217.033 219.322 219.167 219.025C221.301 218.729 223.24 217.625 224.584 215.941L226.112 214.038L220.752 196.766L218.246 195.935L208.129 213.971Z",
    fill: "#263238"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M220.095 202.903C219.637 202.904 219.193 202.748 218.836 202.46C218.48 202.172 218.234 201.77 218.139 201.322L205.904 145.391C205.841 145.13 205.83 144.86 205.872 144.595C205.915 144.33 206.01 144.077 206.152 143.849C206.294 143.622 206.48 143.425 206.699 143.27C206.918 143.116 207.166 143.007 207.428 142.95C207.69 142.892 207.961 142.888 208.224 142.937C208.488 142.986 208.739 143.087 208.963 143.235C209.187 143.383 209.379 143.573 209.528 143.796C209.677 144.019 209.78 144.27 209.831 144.533L222.065 200.465C222.176 200.987 222.077 201.532 221.789 201.981C221.5 202.431 221.045 202.748 220.524 202.863C220.383 202.89 220.239 202.904 220.095 202.903Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M287.39 86.6581C287.028 86.6591 286.673 86.5625 286.362 86.3785C286.05 86.1946 285.795 85.9301 285.621 85.6129C285.474 85.3315 281.936 78.6449 283.906 73.2313C284.349 71.9983 285.06 70.8785 285.986 69.9519C286.913 69.0254 288.033 68.3149 289.266 67.8713C290.528 67.2879 291.904 66.9924 293.295 67.0063C294.685 67.0202 296.055 67.3431 297.306 67.9517C301.795 70.2431 303.282 75.9917 303.349 76.2463C303.479 76.7634 303.398 77.3108 303.124 77.7682C302.85 78.2255 302.406 78.5554 301.889 78.6851C301.371 78.8148 300.824 78.7338 300.367 78.4599C299.909 78.186 299.58 77.7416 299.45 77.2245C299.45 77.2245 298.324 72.9767 295.43 71.5161C294.69 71.1836 293.885 71.0196 293.074 71.0358C292.263 71.0521 291.466 71.2481 290.74 71.6099C290.042 71.8429 289.404 72.2266 288.872 72.7338C288.339 73.241 287.925 73.8591 287.658 74.5445C286.532 77.6265 288.341 82.1691 289.145 83.6565C289.38 84.1239 289.425 84.6642 289.27 85.1639C289.115 85.6635 288.772 86.0838 288.314 86.3365C288.038 86.5187 287.72 86.6293 287.39 86.6581Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M474.628 411.89C474.628 411.89 468.786 420.439 464.015 424.78C451.664 435.952 441.038 448.895 432.485 463.185C420.425 483.714 411.943 504.725 403.93 522.842C395.916 540.958 381.458 574.525 374.128 584.736C366.798 594.947 361.961 600.401 361.961 600.401C361.961 600.401 349.968 600.669 335.764 599.423C321.56 598.176 315.664 595.59 315.516 599.289C315.369 602.987 325.111 613.171 332.159 614.926C339.208 616.682 348.239 619.415 350.383 621.519C352.527 623.623 355.301 626.035 358.798 624.494C362.296 622.953 372.989 608.066 384.901 597.801C396.814 587.537 410.991 577.38 423.842 553.42C436.692 529.461 437.349 515.9 446.34 506.882C455.332 497.864 464.859 483.807 476.343 476.384C487.827 468.96 522.158 455.212 533.119 440.901C544.08 426.589 538.358 409.21 527.759 402.992C517.16 396.774 482.869 394.604 474.628 411.89Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M382.61 569.647C380.137 574.868 377.303 579.91 374.128 584.736C366.785 594.933 361.961 600.401 361.961 600.401C361.961 600.401 349.968 600.669 335.764 599.422C321.56 598.176 315.664 595.59 315.516 599.288C315.369 602.987 325.111 613.171 332.159 614.926C339.207 616.682 348.239 619.415 350.383 621.519C352.527 623.623 355.301 626.035 358.798 624.494C362.296 622.953 372.989 608.065 384.901 597.801C390.436 593.031 396.479 588.26 402.643 582.136C394.823 580.173 387.816 575.805 382.61 569.647Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M358.798 624.44C360.715 623.153 362.423 621.581 363.863 619.777C354.242 617.861 349.257 613.01 344.862 611.737C340.834 610.543 336.982 608.822 333.405 606.618L338.202 599.516L335.764 599.315C321.56 598.056 315.664 595.483 315.516 599.181C315.369 602.88 325.111 613.064 332.159 614.819C339.207 616.575 348.239 619.308 350.383 621.412C352.527 623.516 355.301 626.035 358.798 624.44Z",
    fill: "#7764F5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M375.468 457.207C377.351 465.279 380.124 473.117 383.736 480.577C389.431 491.967 401.973 503.933 411.085 510.781C420.197 517.628 449.556 543.825 464.082 564.622C465.904 567.235 458.95 576.025 450.401 583.717C441.851 591.408 438.153 594.249 442.709 595.683C447.265 597.117 458.092 596.541 468.919 587.415C479.747 578.29 486.875 572.313 490.292 564.903C492.008 561.205 482.601 556.649 476.892 551.798C471.184 546.947 450.092 515.055 443.553 500.235C437.014 485.414 420.492 464.336 408.244 456.939",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M375.468 457.207C377.351 465.279 380.124 473.117 383.736 480.577C389.431 491.967 401.973 503.933 411.085 510.781C420.197 517.628 449.556 543.825 464.082 564.622C465.904 567.235 458.95 576.025 450.401 583.717C441.851 591.408 438.153 594.249 442.709 595.683C447.265 597.117 458.092 596.541 468.919 587.415C479.747 578.29 486.875 572.313 490.292 564.903C492.008 561.205 482.601 556.649 476.892 551.798C471.184 546.947 450.092 515.055 443.553 500.235C437.014 485.414 420.492 464.336 408.244 456.939",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M490.293 564.904C492.008 561.206 482.601 556.65 476.893 551.799C472.095 547.779 456.431 524.53 447.667 508.437L428.277 525.575C440.337 536.724 455.077 551.719 464.069 564.623C465.891 567.236 458.937 576.026 450.387 583.718C441.838 591.409 438.14 594.25 442.696 595.684C447.252 597.118 458.079 596.542 468.906 587.416C479.733 578.291 486.876 572.314 490.293 564.904Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M484.437 557.347C482.909 559.638 480.912 562.707 478.608 566.62C473.248 575.732 458.387 587.416 456.39 585.38C455.19 584.022 454.181 582.507 453.389 580.877C452.424 581.815 451.432 582.753 450.401 583.678C441.865 591.369 438.153 594.21 442.709 595.644C447.265 597.078 458.092 596.502 468.919 587.376C479.747 578.251 486.875 572.274 490.292 564.864C491.324 562.667 488.269 560.12 484.437 557.347Z",
    fill: "#7764F5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M561.809 583.423H464.94V587.979H561.809V583.423Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M473.771 461.201L456.82 623.261C456.807 623.444 456.832 623.629 456.893 623.802C456.955 623.976 457.052 624.135 457.177 624.269C457.303 624.404 457.455 624.511 457.624 624.584C457.793 624.657 457.976 624.695 458.16 624.694C458.481 624.699 458.793 624.587 459.039 624.381C459.285 624.174 459.448 623.886 459.5 623.569L484.692 461.201H473.771Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M551.263 461.201L568.16 623.261C568.173 623.444 568.148 623.629 568.086 623.802C568.025 623.976 567.928 624.135 567.802 624.269C567.677 624.404 567.524 624.511 567.355 624.584C567.186 624.657 567.004 624.695 566.82 624.694C566.499 624.699 566.187 624.587 565.941 624.381C565.695 624.174 565.531 623.886 565.48 623.569L540.288 461.201H551.263Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M520.496 461.202L521.34 623.342C521.34 623.697 521.199 624.038 520.948 624.289C520.696 624.541 520.356 624.682 520 624.682C519.66 624.683 519.333 624.554 519.084 624.323C518.836 624.092 518.684 623.775 518.66 623.436L509.615 461.188L520.496 461.202Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M557.99 436.692H465.61C461.932 436.692 458.95 439.674 458.95 443.352V456.243C458.95 459.921 461.932 462.903 465.61 462.903H557.99C561.668 462.903 564.649 459.921 564.649 456.243V443.352C564.649 439.674 561.668 436.692 557.99 436.692Z",
    fill: "#7764F5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M377.759 467.472C375.763 460.92 367.495 447.815 407.105 420.452C428.09 405.953 473.489 394.818 473.489 394.818L477.764 389.967C477.764 389.967 490.011 402.791 513.944 401.933C537.876 401.075 552.683 390.543 555.484 391.401C558.284 392.258 558.619 399.655 557.48 413.618C556.341 427.581 554.921 434.709 543.799 438.126C532.677 441.543 508.195 442.682 490.52 442.401C481.765 442.372 473.016 441.894 464.31 440.967C464.31 440.967 426.415 464.9 402.777 466.615",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M377.759 467.472C375.763 460.92 367.495 447.815 407.105 420.452C428.09 405.953 473.489 394.818 473.489 394.818L477.764 389.967C477.764 389.967 490.011 402.791 513.944 401.933C537.876 401.075 552.683 390.543 555.484 391.401C558.284 392.258 558.619 399.655 557.48 413.618C556.341 427.581 554.921 434.709 543.799 438.126C532.677 441.543 508.195 442.682 490.52 442.401C481.765 442.372 473.016 441.894 464.31 440.967C464.31 440.967 426.415 464.9 402.777 466.615",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M465.502 310.478C463.787 311.027 411.661 321.305 407.105 320.447C402.549 319.59 390.57 309.339 386.295 309.634C382.02 309.928 373.485 311.335 372.627 313.654C371.769 315.972 374.624 323.623 374.624 323.623C374.624 323.623 371.769 327.898 373.19 329.894C374.61 331.891 382.878 327.054 382.878 327.054C382.878 327.054 392.258 333.888 396.559 332.414C400.861 330.94 405.39 329.291 405.39 329.291C405.39 329.291 472.39 333.311 473.194 333.566C473.998 333.821 482.319 335.549 483.177 323.583C484.035 311.617 475.472 307.342 465.502 310.478Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M374.624 323.583L386.295 313.895",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M378.898 319.308L385.156 299.65L387.729 300.227L384.593 314.471L378.898 319.308Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M483.177 261.474C483.177 261.474 470.796 272.569 467.741 282.271C463.546 295.537 457.53 313.332 462.662 326.156C464.028 329.813 466.196 333.119 469.006 335.829C471.817 338.54 475.198 340.587 478.903 341.82C478.903 341.82 474.883 379.434 476.049 389.404C477.214 399.373 492.571 411.058 515.646 411.916C538.72 412.773 558.673 404.506 558.673 396.519C558.673 388.533 542.432 346.095 542.432 337.264C542.432 328.434 543.853 300.79 536.161 276.013C528.469 251.236 501.401 243.237 483.177 261.474Z",
    fill: "#7764F5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M486.674 330.618C486.674 330.618 507.605 364.426 538.184 374.074",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M484.263 336.246C484.263 336.246 492.303 362.805 513.233 375.682",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M481.462 265.749C477.065 268.549 473.043 271.899 469.496 275.719C462.943 282.566 431.319 330.431 431.319 330.431C431.319 330.431 440.699 350.089 443.567 350.651C446.435 351.214 495.988 308.776 500.557 303.644C505.126 298.512 507.954 289.119 506.534 285.125",
    fill: "#7764F5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M481.462 265.749C477.065 268.549 473.043 271.899 469.496 275.719C462.943 282.566 431.319 330.431 431.319 330.431C431.319 330.431 440.699 350.089 443.567 350.651C446.435 351.214 495.988 308.776 500.557 303.644C505.126 298.512 507.954 289.119 506.534 285.125",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M424.137 333.66C424.137 333.66 407.762 337.921 398.395 339.958C380.975 343.75 354.778 345.733 354.778 345.733C354.757 342.902 354.406 340.082 353.733 337.331C352.675 333.66 351.053 333.66 349.003 328.93C346.953 324.199 343.214 325.767 343.214 327.871C343.515 330.366 344.044 332.829 344.795 335.228L323.932 327.496C323.555 327.351 323.143 327.329 322.753 327.432C322.363 327.536 322.016 327.76 321.761 328.072C321.606 328.271 321.493 328.5 321.429 328.743C321.364 328.987 321.348 329.241 321.383 329.491C321.418 329.741 321.503 329.981 321.632 330.198C321.761 330.414 321.933 330.603 322.136 330.752L332.186 336.782L316.24 332.588C315.809 332.484 315.356 332.529 314.954 332.717C314.552 332.904 314.226 333.223 314.029 333.62C313.909 333.852 313.836 334.107 313.815 334.368C313.794 334.629 313.825 334.892 313.906 335.141C313.987 335.39 314.116 335.621 314.287 335.82C314.458 336.019 314.666 336.182 314.9 336.3L329.037 343.04L315.838 342.222C315.44 342.2 315.047 342.323 314.733 342.57C314.42 342.817 314.207 343.17 314.136 343.562C314.071 343.975 314.165 344.396 314.399 344.742C314.633 345.087 314.989 345.332 315.396 345.425L330.605 348.815L318.92 351.361C318.525 351.445 318.177 351.676 317.946 352.007C317.715 352.338 317.617 352.744 317.674 353.143C317.738 353.51 317.926 353.842 318.207 354.086C318.487 354.33 318.843 354.471 319.215 354.483C324.186 354.617 346.363 356.534 348.159 356.534C350.263 356.534 363.636 358.088 363.636 358.088C363.636 358.088 406.703 362.47 435.326 354.725L424.137 333.66Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M420.492 333.271C420.492 333.271 429.323 354.363 431.319 356.641C433.316 358.919 443.848 357.499 447.265 354.926C450.682 352.353 450.119 347.234 450.119 347.234C450.119 347.234 437.014 324.159 435.594 323.02C434.173 321.881 433.597 324.441 427.554 326.437C421.51 328.434 419.42 329.292 420.492 333.271Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M469.362 248.544C472.244 251.614 474.929 254.864 477.402 258.272C479.678 261.352 481.725 264.594 483.526 267.974L515.176 254.695C515.176 254.695 498.842 240.906 496.282 230.695C495.255 226.018 493.912 221.416 492.262 216.92L469.362 248.544Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M434.736 207.7C434.736 207.7 434.16 215.955 435.594 218.528C437.028 221.1 440.954 223.646 440.954 227.063C440.954 230.48 438.1 235.103 438.957 237.609C439.815 240.115 444.317 240.463 444.317 240.463C444.317 240.463 452.92 250.942 455.6 254.6C458.28 258.259 459.312 256.878 463.292 255.739C467.272 254.6 475.834 247.19 480.712 241.495C485.589 235.8 477.576 218.42 467.044 206.736C456.511 195.051 440.82 195.332 437.403 198.763C433.986 202.193 434.736 207.7 434.736 207.7Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M440.002 219.238C440.002 219.238 441.007 215.606 446.126 218.46",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M446.461 224.625C447.346 226.219 447.6 227.774 447.038 228.082C446.475 228.39 445.322 227.332 444.438 225.737C443.554 224.142 443.299 222.601 443.862 222.293C444.425 221.985 445.59 223.03 446.461 224.625Z",
    fill: "#263238"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M437.121 223.553L440.86 229.14C441.566 230.171 442.61 230.922 443.811 231.265C445.012 231.607 446.296 231.519 447.439 231.016H447.573C448.834 230.451 449.829 229.42 450.348 228.139C450.867 226.858 450.872 225.426 450.36 224.142L448.31 219.023",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M449.905 217.925L436.599 223.834",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M449.905 217.925L467.74 210.983",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M473.355 271.551C473.355 271.551 473.797 263.873 477.442 258.271C481.087 252.67 492.758 243.464 505.006 241.428C517.253 239.391 520.831 252.148 520.831 256.235C520.831 260.322 493.777 259.799 473.355 271.551Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M523.94 219.13C523.94 219.13 517.682 205.891 514.238 196.243C510.794 186.595 503.893 174.884 488.055 166.616C472.216 158.348 450.776 164.485 450.776 164.485L455.6 168.626C455.6 168.626 450.776 165.865 440.444 169.966C430.113 174.066 423.909 178.917 421.148 183.044C418.561 187.489 416.26 192.094 414.261 196.833L427.353 189.945C427.353 189.945 420.465 196.833 419.085 203.037C418.182 208.268 417.733 213.567 417.745 218.876C421.866 214.59 427.078 211.51 432.82 209.965C437.993 208.83 442.903 206.725 447.292 203.761L443.151 212.028H454.26C461.844 212.028 465.971 209.965 465.971 209.965V216.156C465.971 216.156 466.655 224.423 464.631 229.944C462.608 235.465 456.364 240.959 456.364 240.959C458.642 241.342 460.942 241.574 463.251 241.656C466.012 241.656 472.216 238.212 472.216 238.212C472.216 238.212 470.876 245.783 469.455 248.543C468.035 251.304 463.318 255.779 463.318 255.779C463.318 255.779 469.455 257.495 481.167 252.671C483.257 251.813 485.683 256.959 487.934 256.181C490.522 255.803 493.079 255.238 495.585 254.493C506.305 251.424 512.255 238.413 512.255 238.413L514.801 244.537C514.801 244.537 519.397 238.413 519.397 231.271C519.397 227.17 517.066 222.253 515.056 218.795C521.126 217.362 523.94 219.13 523.94 219.13Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M465.918 332.146C469.078 336.698 473.637 340.095 478.903 341.821C478.903 341.821 478.018 350.102 477.201 359.924L484.289 341.499L494.098 356.668L486.728 335.161L487.398 333.419L498.855 346.431L489.904 326.88L498.775 303.832L465.918 332.146Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4192 625.793H638.537",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M194.118 410.745L174.46 407.402L142.326 596.39L161.983 599.733L194.118 410.745Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M135.68 408.361L116.399 413.444L165.271 598.81L184.552 593.727L135.68 408.361Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M214.045 416.936L194.474 413.121L157.797 601.28L177.368 605.095L214.045 416.936Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M201.469 498.373H125.009V625.807H201.469V498.373Z",
    fill: "#7764F5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.a93f577a383f405ab51408447c29ad87.svg";
export { ForwardRef as ReactComponent };